'use strict';

angular.module('schoolbushubApp')
    .controller('AdministrationController', function ($scope, Principal) {
        Principal.identity().then(function(account) {
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;
        });
    });
